<template>
  <div id="parent-container">
    <div
      id="dragBox"
      @wheel="handleWeel"
      ref="back_box"
    >
      <div
        class="drag-scroll-out-wrapper"
        id="drag-scroll-out-wrapper"
      >
        <div
          class="drag-scroll-wrapper"
          id="drag-scroll-wrapper"
          :style="zoomStye"
          @click="clickDragScrollWrapper"
          @mousedown="checkMouseDown"
        >
          <div
            v-for="(product, index) in selectedProductList"
            :key="index"
          >
            <!-- 点击产品后出现产品信息和删除选项 -->
            <div
              v-if="product"
              id="ppp"
            >
              <el-popover
                placement="bottom"
                trigger="click"
                class="box"
                :style="`left:${product.productOriginLeft}px !important;top:${product.productOriginTop}px !important`"
                :id="'a' + index"
                :class="{
                  selected:
                    index === selectedBlockIndex && allSelectedHighLight,
                }"
                @mousedown.native="mousedownProduct(index)"
                @click.native="clickProduct(index)"
                @mouseup.native="mouseupProduct(index)"
                width="100"
              >
                <span
                  style="font-size: xx-small; letter-spacing: -1px"><strong>{{ product.title }}</strong>
                  / ({{ product.selectedVariant.title }})</span>
                <div
                  class="button-group"
                  style="text-align: center"
                >
                  <el-button
                    @click="rotateDiv(index)"
                    type="text"
                    style="font-size: 1.2rem; color: #1e1e1e"
                    icon="el-icon-refresh-right"
                  ></el-button>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="delRow(index)"
                    style="font-size: 1.2rem; color: #1e1e1e"
                  ></el-button>
                </div>

                <span
                  slot="reference"
                  class="row"
                  v-if="product"
                >
                  <img
                    :src="product.selectedVariant.image_src"
                    class="box-img rotating-div"
                    :height="250 * product.custom_zoom"
                    :style="product.style"
                  />

                  <!-- 吸附点 -->
                  <!-- 注意：top和left中有个-5px，是根据管子接口的圆点直径10px，中心点就是（5px，5px）来算的 -->
                  <span
                    v-for="(points, k) in product.custom_points"
                    :key="k"
                    class="adsorb-point unconnected"
                    :id="`adsorb-point-${index}-${k}`"
                    :parent-index="index"
                    :style="`
                        position: absolute;
                        top: ${250 * product.custom_zoom * points.height_ratio - 5}px;
                        left: ${250 * product.custom_zoom * points.width_ratio - 5}px;
                    `"
                  >
                  </span>

                </span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>

      <div class="selectedList">
        <span
          v-for="(selected, index) in selectedProductList"
          :key="index"
        >
          <span
            v-if="selected"
            :class="{
              selectedListHighLight:
                index === selectedBlockIndex && allSelectedHighLight,
            }"
          >
            {{ selected.title }} - {{ selected.selectedVariant.title }}<br />
          </span>
        </span>
      </div>

      <div class="zoomDiv">
        <el-slider
          v-model="zoom"
          :min="minZoom"
          :max="maxZoom"
          :step="sliderStep"
          :show-tooltip="false"
          vertical
          height="100px"
        >
        </el-slider>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'DesignPage',
    data() {
      return {
        allSelectedHighLight: true, //当点击空白处时取消所有产品高亮
        zoom: 0.8, // 缩放比例
        minZoom: 0.4,
        maxZoom: 1.2,
        sliderStep: 0.05, // 缩放最小单位
        elWidth: 0,
        elHeight: 0,
        scale: 100,
        isParentDragscroll: false, // true:整块背景一起拖动，false：只有小div可拖动
        drawDivWidth: 2500, // 设计面板宽度
        drawDivHeight: 2500, // 设计面板高度
      };
    },
    computed: {
      ...mapState([
        'selectedProduct',
        'selectedProductList',
        'selectedBlockIndex',
      ]),
      zoomStye() {
        const INIT_WIDTH = this.drawDivWidth;
        const INIT_HEIGHT = this.drawDivHeight;
        const width = INIT_WIDTH;
        const height = INIT_HEIGHT;
        return {
          width: `${width}px`,
          height: `${height}px`,
          transform: `scale(${(this.zoom * 100) / 100})`,
        };
      },
    },
    updated() {},
    mounted() {
      this.initBodySize();
    },
    beforeDestroy() {
      // document.getElementById("dragBox").removeEventListener("click", this.handleClickOutside, true);
    },
    created() {},

    watch: {
      selectedProductList: {
        handler(newVal) {
          this.$nextTick(() => {
            this.childrenDrag();
            this.parentDrag();
          });
        },
      },
      zoom: {
        handler(newVal) {
          this.$nextTick(() => {
            this.parentDrag();
            this.childrenDrag();
          });
        },
      },
    },
    methods: {
      ...mapMutations([
        'setSelectedProductList',
        'setShowDiv',
        'setSelectedBlockIndex',
        'setlargeImgURL',
        'changeSelectedProductList',
        'setProductOriginLeft',
        'setProductOriginTop',
      ]),
      // 页面初始化
      initBodySize() {
        this.initWidth = this.$refs.back_box.clientWidth; // 拿到父元素宽
        this.initHeight = this.$refs.back_box.clientHeight;
        this.elWidth = this.initWidth * (100 / (1920 / 2));
        this.elHeight = this.initHeight * (100 / (1080 / 2));

        document
          .getElementById('dragBox')
          .addEventListener('click', this.handleClickOutside, true);
        this.$store.commit('setCanvasFunction', this.renderCanvasPlus);
        // this.drag(document.get ElementById("dragBox"), document.getElementById("parent-container"))

        // 默认窗口定位到画板中心
        let drag_scroll_out_wrapper = document.getElementById(
          'drag-scroll-out-wrapper'
        );
        drag_scroll_out_wrapper.scrollTo(
          this.drawDivWidth / 2 - drag_scroll_out_wrapper.clientWidth / 2 + 200,
          this.drawDivHeight / 2 - drag_scroll_out_wrapper.clientHeight / 2 + 200
        );

        this.initProductOriginPostion();
      },
      // 初始化产品生成原始位置
      initProductOriginPostion() {
        // 获取窗口的距离
        let drag_scroll_out_wrapper = document.getElementById(
          'drag-scroll-out-wrapper'
        );
        let drag_scroll_wrapper = document.getElementById('drag-scroll-wrapper');
        let rect1 = drag_scroll_wrapper.getBoundingClientRect();
        let rect2 = drag_scroll_out_wrapper.getBoundingClientRect();
        let dx = rect2.left - rect1.left;
        let dy = rect2.top - rect1.top;
        dx = dx < 0 ? 0 : dx;
        dy = dy < 0 ? 0 : dy;
        // 设置产品初始位置
        this.setProductOriginLeft(dx / this.zoom);
        this.setProductOriginTop(dy / this.zoom);
      },
      // 初始化拖拽事件
      childrenDrag() {
        var obox = document.getElementById('drag-scroll-wrapper');
        for (
          let index = 0;
          index < this.$store.state.selectedProductList.length;
          index++
        ) {
          if (!this.$store.state.selectedProductList[index]) {
            continue;
          }
          // 对多个元素绑定拖拽事件，要先点击，然后才能拖拽（先点击获取元素对象）
          var obj = document.getElementById('a' + index);
          // 为每个元素加入拖拽事件
          this.drag(obj, obox);
        }
      },
      drag(box, obox) {
        var disX;
        var disY;
        var zoom = this.zoom;
        // 鼠标左键按下事件
        box.onmousedown = function (ev) {
          var that = this;
          that.isDrag = true;

          ev.preventDefault();
          var oEvent = ev || event;
          // clientX，clientY：鼠标点击位置到浏览器可视区域x，y距离
          // offsetLeft，offsetTop:元素距离父级元素的偏移距离
          disX = oEvent.clientX / zoom - box.offsetLeft;
          disY = oEvent.clientY / zoom - box.offsetTop;
          // 鼠标移动事件
          document.onmousemove = function (ev) {
            // 加入该判断拖拽更流畅
            if (that.isDrag) {
              var oEvent = ev || event;
              // 计算点击元素到父级元素的定位top，left距离
              var l = oEvent.clientX / zoom - disX;
              var t = oEvent.clientY / zoom - disY;

              // 设置拖拽边界(限定在浏览器可视区域（空白区域）之内)
              // 限定左边界
              // if(l<0){
              //   l=0
              // }else if(l>document.documentElement.clientWidth-box.offsetWidth){
              //   限定右边界
              //   l=document.documentElement.clientWidth-box.offsetWidth
              // }
              // 限定上边界
              // if(t<0){
              //   t=0
              // }else if(t>document.documentElement.clientHeight-box.offsetHeight){
              //   限定下边界
              //   t=document.documentElement.clientHeight-box.offsetHeight
              // }
              /** 限定拖拽范围，限定拖拽元素在指定的范围内 */

              obox.style.boxShadow = 'none';

              // 限定左边界和上边界
              if (l < 0) {
                obox.style.boxShadow = '-5px 0 10px rgba(0, 0, 0, 0.5)';
                l = 0;
              }
              if (t < 0) {
                obox.style.boxShadow = '0 -5px 10px rgba(0, 0, 0, 0.5)';
                t = 0;
              }
              // 限定右边界的距离(当l=父元素宽-子元素宽时，刚好子元素放在父元素最右边)
              if (l > obox.clientWidth - box.clientWidth) {
                obox.style.boxShadow = '5px 0 10px rgba(0, 0, 0, 0.5)';
                l = obox.clientWidth - box.clientWidth;
              }
              // 限定下边界的距离(当t=父元素高-子元素高时，刚好子元素放在父元素最下边)
              if (t > obox.clientHeight - box.clientHeight) {
                obox.style.boxShadow = '0 5px 10px rgba(0, 0, 0, 0.5)';
                t = obox.clientHeight - box.clientHeight;
              }

              box.style.left = l + 'px';
              box.style.top = t + 'px';
            }
          };

          document.onmouseup = function () {
            that.isDrag = false;
            document.onmousemove = null;
            document.onmouseup = null; //鼠标抬起来后，onmouseup事件本身也没意义了，所以最好清理掉
          };
          return false; //阻止默认行为，空的div在低版本ff下，第二次拖动手型会变异常
        };
      },
      parentDrag() {
        var zoom = this.zoom;
        let el = document.getElementById('drag-scroll-out-wrapper');
        if (this.isParentDragscroll) {
          el.onmousedown = async function (ev) {
            el.style['scroll-behavior'] = 'auto';
            el.style['cursor'] = 'grabbing';
            const disX = ev.clientX;
            const disY = ev.clientY;
            const originalScrollLeft = el.scrollLeft;
            const originalScrollTop = el.scrollTop;
            const originalScrollBehavior = el.style['scroll-behavior'];
            const originalPointerEvents = el.style['pointer-events'];

            document.onmousemove = function (ev) {
              ev.preventDefault();
              const distanceX = ev.clientX - disX;
              const distanceY = ev.clientY - disY;
              el.scrollTo(
                originalScrollLeft - distanceX,
                originalScrollTop - distanceY
              );
              el.style['cursor'] = 'grabbing';
            };
            document.onmouseup = function () {
              document.onmousemove = null;
              document.onmouseup = null;
              el.style['scroll-behavior'] = originalScrollBehavior;
              el.style['pointer-events'] = originalPointerEvents;
              el.style['cursor'] = 'grab';
            };
          };
        } else {
          el.onmousedown = null;
        }
      },

      mouseupProduct(index) {
        let pointLength = this.selectedProductList[index].custom_points.length;

        // 判断所有点中，可以连接的两个点（去除点效果）
        let allPoints = document.querySelectorAll('.adsorb-point');
        let minDistance = 9999; // 足够大就行
        let currPoint = '';
        let theOtherPoint = '';

        let box = document.getElementById(`a${index}`);

        for (let i = 0; i < pointLength; i++) {
          let currentPoint = document.getElementById(
            `adsorb-point-${index}-${i}`
          );

          let targetRect = currentPoint.getBoundingClientRect();

          allPoints.forEach((point) => {
            if (
              point !== currentPoint &&
              point.getAttribute('parent-index') != index
            ) {
              let boxRect = point.getBoundingClientRect();
              let distance = Math.sqrt(
                Math.pow(targetRect.left - boxRect.left, 2) +
                  Math.pow(targetRect.top - boxRect.top, 2)
              );

              // 获取最小距离
              if (distance < minDistance) {
                minDistance = distance;
                theOtherPoint = point;
                currPoint = currentPoint;
              }
            }
          });
        }

        if (minDistance < 100 * this.zoom) {
          let currPointRect = currPoint.getBoundingClientRect();
          let theOtherPointRect = theOtherPoint.getBoundingClientRect();

          let topDifference =
            (theOtherPointRect.top - currPointRect.top) / this.zoom;
          let leftDifference =
            (theOtherPointRect.left - currPointRect.left) / this.zoom;

          box.style.top = `${box.offsetTop + topDifference}px`;
          box.style.left = `${box.offsetLeft + leftDifference}px`;

          theOtherPoint.classList.remove('unconnected');
          theOtherPoint.classList.add('connected');

          currPoint.classList.remove('unconnected');
          currPoint.classList.add('connected');
        }

        // 在已经连接的点中，判断是否有重新断开的两个点（增加点效果）
        let allConnectedPoints = document.querySelectorAll('.connected');
        let resPoints = Array.from(allConnectedPoints);

        for (let i = 0; i < allConnectedPoints.length; i++) {
          let point1 = allConnectedPoints[i];
          for (let j = 1; j <= allConnectedPoints.length - 1; j++) {
            let point2 = allConnectedPoints[j];
            if (
              point1 !== point2 &&
              point1.getAttribute('parent-index') !=
                point2.getAttribute('parent-index')
            ) {
              let point1Rect = point1.getBoundingClientRect();
              let point2Rect = point2.getBoundingClientRect();
              let distance = Math.sqrt(
                Math.pow(point1Rect.left - point2Rect.left, 2) +
                  Math.pow(point1Rect.top - point2Rect.top, 2)
              );

              // 如果存在已经连接的点中，存在距离小于100的则排除
              if (distance < 100 * this.zoom) {
                resPoints[i] = null;
                resPoints[j] = null;
              }
            }
          }
        }

        resPoints.forEach((item) => {
          if (item) {
            item.classList.remove('connected');
            item.classList.add('unconnected');
          }
        });

        let product = JSON.parse(JSON.stringify(this.selectedProductList[index]));
        let left = parseFloat(box.style.left.replace('px', ''));
        let top = parseFloat(box.style.top.replace('px', ''));
        product.productOriginLeft = left;
        product.productOriginTop = top;
        this.changeSelectedProductList(product);
      },
      handleWeel(ev) {
        // 阻止滚轮的默认行为
        ev.preventDefault();
        if (ev.wheelDelta < 0) {
          if (this.zoom > this.minZoom) {
            this.TransformWhileZoom(-this.sliderStep);
          }
          this.zoom -= this.sliderStep;
        } else {
          if (this.zoom < this.maxZoom) {
            this.TransformWhileZoom(this.sliderStep);
          }
          this.zoom += this.sliderStep;
        }

        if (this.zoom >= this.maxZoom) {
          this.zoom = this.maxZoom;
          return;
        }
        if (this.zoom <= this.minZoom) {
          this.zoom = this.minZoom;
          return;
        }
      },
      TransformWhileZoom(value) {
        for (
          let index = 0;
          index < this.$store.state.selectedProductList.length;
          index++
        ) {
          if (!this.$store.state.selectedProductList[index]) {
            continue;
          }
          var obj = document.getElementById('a' + index);
          obj.style.left =
            (obj.style.left / this.zoom) * (this.zoom + value) + 'px';
          obj.style.top =
            (obj.style.top / this.zoom) * (this.zoom + value) + 'px';
        }
      },

      mousedownProduct(index) {
        this.setSelectedBlockIndex(index);
      },
      clickProduct(index) {
        this.allSelectedHighLight = true;
        this.setShowDiv(true);
        this.setSelectedBlockIndex(index);
      },
      delRow(index) {
        // 这个深度拷贝对一些特定类型无法拷贝
        let list = JSON.parse(JSON.stringify(this.selectedProductList));
        list[index] = null;
        this.setSelectedProductList(list);
        this.setShowDiv(false);
      },
      handleClickOutside() {
        this.setSelectedBlockIndex(-1);
        this.setShowDiv(false);
        this.allSelectedHighLight = false;
      },
      renderCanvas() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d'); //获取它的2D渲染上下文context
        const largeImage = new Image();
        largeImage.setAttribute('crossOrigin', 'anonymous');
        var minx = 999;
        var maxx = 0;
        var miny = 999;
        var maxy = 0;
        var maxWidth = 0;
        var maxHeight = 0;
        var totalPrice = 0;
        const imgArray = []; //该数组用来存放图片地址
        //将第一个元素的值赋给minx,miny
        if (this.$store.state.selectedProductList[0]) {
          var obj = document.getElementById('a0');
          minx = obj.offsetLeft;
          miny = obj.offsetTop;
        }

        for (
          let index = 0;
          index < this.$store.state.selectedProductList.length;
          index++
        ) {
          if (!this.$store.state.selectedProductList[index]) {
            continue;
          }
          var obj = document.getElementById('a' + index);
          if (obj.offsetLeft < minx) {
            minx = obj.offsetLeft;
          }
          if (obj.offsetTop < miny) {
            miny = obj.offsetTop;
          }
          if (obj.offsetLeft + obj.clientWidth > maxx) {
            maxx = obj.offsetLeft + obj.clientWidth;
          }
          if (obj.offsetTop + obj.clientHeight > maxy) {
            maxy = obj.offsetTop + obj.clientHeight;
          }
        }
        //组合后的图片的宽高
        maxHeight = maxy - miny;
        maxWidth = maxx - minx;
        //设置最小width值,防止生成后的图片太小,填充时被拉大而模糊不清
        if (maxWidth < 500) {
          maxWidth = 500;
        }
        this.selectedProductList.forEach((element, index) => {
          if (element && element != null) {
            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.src = element.selectedVariant.image_src;
            img.setAttribute('data-rotate', element.rotation); // 传入旋转的角度
            img.index = index;
            imgArray.push(img);
            totalPrice += parseInt(element.selectedVariant.price);
          }
        });
        //canvas的宽高
        canvas.width = maxWidth;
        canvas.height = maxHeight;
        Promise.all(
          imgArray.map((img) => {
            return new Promise((resolve) => {
              img.onload = () => {
                var obj = document.getElementById('a' + img.index);
                var rotate = img.getAttribute('data-rotate');
                var angleInRadians = rotate * (Math.PI / 180);

                ctx.translate(
                  obj.offsetLeft - minx + obj.clientWidth / 2,
                  obj.offsetTop - miny + obj.clientHeight / 2
                );
                ctx.rotate(angleInRadians);
                ctx.drawImage(
                  img,
                  -obj.clientWidth / 2,
                  -obj.clientHeight / 2,
                  obj.clientWidth,
                  obj.clientHeight
                );
                ctx.setTransform(1, 0, 0, 1, 0, 0); // 重置变换矩阵

                resolve();
              };
            });
          })
        ).then(() => {
          largeImage.onload = () => {
            ctx.drawImage(largeImage, 0, 0);
            const largeImageDataUrl = canvas.toDataURL('image/png');
            this.setlargeImgURL(largeImageDataUrl);
          };
        });
        largeImage.src = canvas.toDataURL('image/png');
      },
      renderCanvasPlus() {
        this.renderCanvas();
        setTimeout(() => {
          this.renderCanvas();
        }, 10);
      },
      setParentDarg(tag) {
        this.isParentDragscroll = tag;
        this.parentDrag();
      },
      checkMouseDown(event) {
        const isInsideInnerDiv = event.target.classList.contains('box-img');
        if (!isInsideInnerDiv) {
          this.setParentDarg(true);
        } else {
          this.setParentDarg(false);
        }
      },
      clickDragScrollWrapper() {
        this.initProductOriginPostion();
      },
      rotateDiv(index) {
        if (!this.selectedProductList[index]) {
          return false;
        }

        let product = JSON.parse(JSON.stringify(this.selectedProductList[index]));

        product.style.transform = `rotate(${(product.rotation += 90)}deg)`;

        let length = this.selectedProductList[index].custom_points.length;

        for (let i = 0; i < length; i++) {
          const point = product.custom_points[i];
          let res = this.rotatePoint(
            point.height_ratio - 0.5,
            point.width_ratio - 0.5
          );
          product.custom_points[i] = {
            width_ratio: res[1] + 0.5,
            height_ratio: res[0] + 0.5,
          };
        }

        this.changeSelectedProductList(product);

        this.childrenDrag();
        this.parentDrag();
      },
      rotatePoint(x, y) {
        // 旋转角度（以弧度为单位）
        const newX = y;
        const newY = -x;

        return [newX, newY];
      },
    },
  };
</script>

<style scoped lang="scss">
  /**********************分割线 ***********************/

  #dragBox {
    position: relative;
    // margin-top: 4rem;
    min-height: 70vh;
    overflow: hidden;
    background-color: #f2f2f2;
  }

  .drag-scroll-out-wrapper {
    /* &::-webkit-scrollbar { width: 0 !important } */
    overflow: scroll;
    width: 100%;
    height: 100%;
    cursor: grab;
    position: absolute;

    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .drag-scroll-wrapper {
    margin: 200px;
    top: 50%; /* 将视口div的顶部与大div的中心垂直对齐 */
    left: 50%; /* 将视口div的左侧与大div的中心水平对齐 */
    transform: translate(
      -50%,
      -50%
    ); /* 使用transform属性将视口div水平和垂直居中 */
  }

  .box {
    position: absolute;
  }

  .box:hover {
    box-shadow: 0 0 0 2px #1f427c; /* 边框效果，不占空间 */
    cursor: pointer;
  }

  .selected {
    box-shadow: 0 0 0 2px #1f427c; /* 边框效果，不占空间 */
  }

  .selectedList {
    position: absolute;
    font-size: 10px;
    bottom: 0;
    left: 0;
    // width: 90%;
    text-align: left;
  }

  .zoomDiv {
    position: absolute;
    bottom: 10%;
    right: 0;
  }

  .selectedListHighLight {
    background-color: #1f427c;
    color: #fff;
  }

  .adsorb-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fff; /* 大圆的颜色 */
    box-shadow: 0 0 0 3px rgb(190, 190, 190);
    transition: transform 0.5s;
  }

  .adsorb-point:hover {
    box-shadow: 0 0 0 4px rgb(190, 190, 190);
  }

  .unconnected {
    visibility: visible;
  }

  .connected {
    visibility: hidden;
  }

  .rotating-div {
    position: relative;
    transform-origin: center center !important;
    transition: transform 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/DesignPage.vue